module.exports = __webpack_public_path__ + "img/glucose_meter_black.9316cfdc.svg";